export enum ActionType {
  zoomIn = 'zoom-in',
  zoomOut = 'zoom-out',
  numbering = 'numbering',
  description = 'description',
  freeHand = 'freeHand',
  shape = 'shape',
  rectangle = 'rectangle',
  circle = 'circle',
  ellipse = 'ellipse',
  svgElement = 'svgElement',
  stroke = 'stroke',
  color = 'color'
}
